module.exports = __webpack_public_path__ + "img/shopInfo_medic.73ae7980.jpg";